import { render, staticRenderFns } from "./AdsNotConfirmed.vue?vue&type=template&id=cec20af6&scoped=true&"
import script from "./AdsNotConfirmed.vue?vue&type=script&lang=js&"
export * from "./AdsNotConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec20af6",
  null
  
)

export default component.exports